import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LuArrowLeft, LuMail } from 'react-icons/lu';
import { api } from '../utils/api';
import AuthCard from '../components/AuthCard';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await api.forgotPassword(email);
      setMessage(response.data.message);
    } catch (_) {
      setError('We could not process the request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Forgot your password?" description="Enter your account email. If it matches an account, we’ll send a one-time reset link valid for 30 minutes.">
      {message ? (
        <div role="status" className="rounded-lg border border-emerald-500/20 bg-emerald-500/10 p-4 text-sm leading-relaxed text-emerald-300">
          {message}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label htmlFor="forgot-email" className="block text-xs font-medium text-zinc-500 mb-2 uppercase tracking-wider">Email</label>
            <div className="relative">
              <LuMail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-600" />
              <input id="forgot-email" type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required className="w-full pl-11 pr-4 py-3 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:border-amber-500/50 outline-none" />
            </div>
          </div>
          {error && <p role="alert" className="text-sm text-red-400">{error}</p>}
          <button disabled={loading} className="w-full py-3.5 bg-gradient-to-r from-amber-500 to-amber-600 text-zinc-900 rounded-lg font-semibold disabled:opacity-50">
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
      <Link to="/auth" className="mt-6 flex items-center justify-center gap-2 text-sm text-zinc-500 hover:text-zinc-300"><LuArrowLeft /> Back to sign in</Link>
    </AuthCard>
  );
};

export default ForgotPassword;
